import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { GroupScreen } from 'screens/group';

export default withPermissions(GroupScreen, [GroupSecurity.GroupRead]);
